
import React, {useState, useCallback, useEffect} from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router";
import { useHistory, withRouter } from "react-router-dom";
import {  c2bTradeRoutesArray, c2bTradeRoutes } from "../../c2b-trade-routes";
import { getCheckoutPageURL } from "../../../utils/helpers/get-detail-page-url";
// import RejectModal from "../reject-modal";
import PageLoader from "../../../../components/shared/page-loader";
import { getQuestionnarieConfigDesktop } from "../../../utils/helpers/get-questionnarie-config";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import jwtDecode from "jwt-decode";
import { LOGIN_TYPE } from "../../../../constants/checkout-constants";

const CheckoutPage = ({
    match: {
        params: { stepid}
    },
    email,
    maxStep,
    setMaxStepConnect,
    setUserUpdatingConnect,
    getOrderDetailsConnect,
    getSeoContentConnect,
    isGuestLogin,
    isLoggedIn,
    secureToken,
    isFetched,
    logoutConnect,
    setLoginTypeConnect,
    openLoginPopupConnect,
    setOnLoginSuccessCallback
    // handleRejectModalConnect
}) => {

    const history = useHistory();
    const [loader, setLoader] = useState(true);

    const {location} = history;
    const queryParams = parseLocationSearchParams(location.search);
    const [currentStep, setCurrentStep] = useState(c2bTradeRoutesArray.find((routeData) => routeData.route === stepid) || {});
    const {orderId} = useParams();

    const updateMaxStep = useCallback(() => {
        const routeIndex = c2bTradeRoutesArray.findIndex((routeData) => routeData.route === stepid);
        const maxStepIndex = c2bTradeRoutesArray.findIndex((routeData) => routeData.route === maxStep);
        if (routeIndex >= maxStepIndex && routeIndex !== -1) {
            setMaxStepConnect(c2bTradeRoutesArray[routeIndex].route);
        }
    }, [maxStep, setMaxStepConnect, stepid]);

    const selectStep = useCallback(() => {
        const route = c2bTradeRoutesArray.find((routeData) => routeData.route === stepid);
        setCurrentStep(route);
    }, [stepid]);

    useEffect(() => {
        selectStep();
        updateMaxStep();
    }, [selectStep, stepid, updateMaxStep]);

    // eslint-disable-next-line complexity
    useEffect(() => {
        const getTradeDetails = (token) => {
            getOrderDetailsConnect(orderId, token)
                .then(response => {
                    if (response === null && currentStep.validateRoute) {
                        history.replace("/sell-your-car/");
                    } else if (response && response.completed) {
                        const route = c2bTradeRoutes.tradeInValuation.route;
                        const { relativeURL } = getCheckoutPageURL(route, orderId, queryParams);
                        history.push(relativeURL);
                    } else if (response && !response.completed) {
                        setUserUpdatingConnect(response.submitted);
                    }

                })
                .catch(() => {
                    history.replace("/sell-your-car/");
                })
                .finally(() => {
                    setLoader(false);
                });
        };
        const { userId } = queryParams;
        if (secureToken && ((isLoggedIn && (!userId || userId === email)) || (isGuestLogin && !userId))) {
            getTradeDetails();
        } else if (
            isFetched && userId
            && ((!isLoggedIn && !isGuestLogin)
            || (isLoggedIn && email && userId !== email)
            || (isGuestLogin && userId))
        ) {
            setLoginTypeConnect(LOGIN_TYPE.C2B_FLOW);
            const showLoginScreen = () => setOnLoginSuccessCallback((resp) =>  {
                const { access_token: token} = resp.profileResponse || resp;
                const { email: loggedInEmail } = jwtDecode(token) || {};
                if (userId === loggedInEmail) getTradeDetails(token);
                else {
                    logoutConnect(() => {
                        showLoginScreen();
                        openLoginPopupConnect();
                    });
                }
            });
            const showLoginScreenUtil = () => {
                showLoginScreen();
                openLoginPopupConnect();
            };
            if (isLoggedIn) logoutConnect(showLoginScreenUtil);
            else showLoginScreenUtil();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, isGuestLogin, isFetched, secureToken]);

    useEffect(() => {
        getSeoContentConnect({
            seoRequest: {
                spath: ""
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // if (!currentStep) return <PageNotFoundAu />;

    const Component = currentStep.component;
    const questionConfig = getQuestionnarieConfigDesktop();

    return (
        loader ?
            <PageLoader/>
            :
            <React.Fragment>
                <Component routeData={currentStep} questionConfig={questionConfig} />
            </React.Fragment>
    );
};

CheckoutPage.propTypes = {
    match: PropTypes.object,
    maxStep: PropTypes.number,
    setMaxStepConnect: PropTypes.func,
    getTradeInDetailsConnect: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    setUserUpdatingConnect: PropTypes.func,
    getOrderDetailsConnect: PropTypes.func,
    getSeoContentConnect: PropTypes.func,
    isGuestLogin: PropTypes.bool,
    secureToken: PropTypes.string,
    isFetched: PropTypes.bool,
    email: PropTypes.string,
    logoutConnect: PropTypes.func,
    setLoginTypeConnect: PropTypes.func,
    openLoginPopupConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func
};

export default withRouter(CheckoutPage);
